import { apiMiddleware } from '@aftonbladet/redux-api-middleware';
import { middleware as spidMiddleware } from '@spp/redux-spid';
import { middlewares as coreNavigationMiddlewares } from '@spp/ui-core-navigation';
import trackers from '../tracking/client-trackers';

export default () => [
    apiMiddleware,
    spidMiddleware,
    trackers.middleware,
    coreNavigationMiddlewares.coreNavigationUI,
];



/** WEBPACK FOOTER **
 ** ./src/redux/middlewares.js
 **/